import React from "react"
import { View, Text, Image, TouchableOpacity, StyleSheet } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { theme } from "@common/theme/theme"

/**
 * La répartition du volume entre les matières, lue d'un coup d'œil : la même
 * icône de matière qu'en haut, le volume à côté. Une matière à 0 h se MONTRE,
 * en gris et en rouge : masquer le zéro est précisément ce qui laissait
 * croire qu'elle serait servie.
 *
 * Le parent ne saisit jamais ces heures. « Répartir autrement » — discret mais
 * trouvable, la couleur de la marque et une icône — est son seul recours, et
 * il n'apparaît que s'il y a de la marge (`canRedistribute`).
 */
const FunnelSubjectHoursSplit = ({
    subjectIds,
    subjectById,
    hoursBySubject,
    canRedistribute = false,
    onOpenRedistribute,
}) => (
    <View style={styles.split}>
        <View style={styles.chips}>
            {subjectIds.map((id) => {
                const hours = hoursBySubject[String(id)] ?? 0
                const subject = subjectById.get(String(id))
                return (
                    <View
                        key={id}
                        style={[styles.chip, !hours && styles.chipEmpty]}
                    >
                        {subject?.iconUri ? (
                            <Image
                                source={{ uri: subject.iconUri }}
                                style={styles.icon}
                                resizeMode="contain"
                            />
                        ) : null}
                        <Text style={styles.text}>
                            {subject?.label ?? "Matière"}
                        </Text>
                        <Text
                            style={[styles.hours, !hours && styles.hoursEmpty]}
                        >
                            {hours} h
                        </Text>
                    </View>
                )
            })}
        </View>
        {canRedistribute ? (
            <TouchableOpacity
                onPress={onOpenRedistribute}
                accessibilityRole="button"
                accessibilityLabel="Répartir autrement les heures entre les matières"
            >
                <View style={styles.redistributeRow}>
                    <FontAwesome5
                        name="sliders-h"
                        size={11}
                        color={theme.colors.primary}
                    />
                    <Text style={styles.redistribute}>Répartir autrement</Text>
                </View>
            </TouchableOpacity>
        ) : null}
    </View>
)

const styles = StyleSheet.create({
    split: { gap: 10 },
    chips: { flexDirection: "row", flexWrap: "wrap", gap: 8 },
    chip: {
        flexDirection: "row",
        alignItems: "center",
        gap: 7,
        borderRadius: 999,
        paddingVertical: 6,
        paddingLeft: 8,
        paddingRight: 11,
        backgroundColor: theme.colors.greyBg,
    },
    chipEmpty: { opacity: 0.55 },
    icon: { width: 17, height: 17 },
    text: {
        fontFamily: "Montserrat-Bold",
        fontSize: 12.5,
        color: theme.colors.primaryDark || theme.colors.primary,
    },
    hours: {
        fontFamily: "Montserrat-ExtraBold",
        fontSize: 12.5,
        color: theme.colors.grey,
    },
    hoursEmpty: { color: theme.colors.error },
    redistributeRow: {
        flexDirection: "row",
        alignItems: "center",
        gap: 6,
        marginTop: 2,
        alignSelf: "flex-start",
    },
    redistribute: {
        fontFamily: "Montserrat-Bold",
        fontSize: 12,
        color: theme.colors.primary,
        textDecorationLine: "underline",
    },
})

export default FunnelSubjectHoursSplit
